import _ from 'lodash';

/**
 * Farmers API Endpoints
 */

class FarmersEndpoints {

    static getUrl(){
        return '/api/farmers'
    }

    static get(id){

        return {
            url: FarmersEndpoints.getUrl(),
            get: id
        };
    }

    static deleteFarmer(id){

        return {
            url : FarmersEndpoints.getUrl(),
            delete: id
        };

    }

    static update(id , payload ){
        return{
            url: FarmersEndpoints.getUrl(),
            update: id,
            content : payload
        };
    }

    static create(fbo,payload){

        return {
            url : `${FarmersEndpoints.getUrl()}/${fbo}/fbo`,
            method: 'post',
            content: payload
        };
    }

    static createFarmerNoFBO(payload){
        return {
            url: FarmersEndpoints.getUrl(),
            content: payload,
            method: 'post'
        };
    }

    static getRequests(farmerId){

        return {
            url: `${FarmersEndpoints.getUrl()}/${farmerId}/requests`,
            method:'get'
        };

    }

    static  getRequestStats(id,timeFrame,range,step){

        return {
            url : `${FarmersEndpoints.getUrl()}/${id}/requests/create/stats`,
            query: {
                'time_frame': timeFrame,
                'time_range': `${range.min},${range.max}`,
                'step': step
            },
            method:'get'
        };
    }

    static getMyRequests(){

        return {
            url: `${FarmersEndpoints.getUrl()}/my/requests`,
            method: "get"
        };

    }

    static assignFarmerToFBO(farmerId, fboId){

        return {
            url: `${FarmersEndpoints.getUrl()}/${farmerId}/assign-fbo/${fboId}`,
            method: 'put'
        };
    }

    static disassociateFBO(farmerId){

        return {
            url : `${FarmersEndpoints.getUrl()}/${farmerId}/fbo`,
            method: 'delete'
        };
    }

    static exportCSV(filtered = true){

        return {
            url: `${FarmersEndpoints.getUrl()}/export/csv${filtered? '/filtered' : ''}`,
            method: "get"
        }

    }

}

class NotificationEndpoints{

    static  getUrl(){
        return '/api/users/notifications';
    }

    static getSummary(){

        return {
            url: `${NotificationEndpoints.getUrl()}/summary`,
            method : 'get'
        }
    }

    static delete(id){

        return {
            url: NotificationEndpoints.getUrl(),
            delete: id
        };
    }

    static clear(type){
        return {
            url: `${NotificationEndpoints.getUrl()}/clear`,
            query: {
                type: type
            },
            method: "delete"
        }
    }

    static getUserNotifications(type){

        return {
            url : NotificationEndpoints.getUrl(),
            method: 'get',
            query: type ? {
                type: type
            } : {}
        };
    }

    static checkAllUnseen(type){

        return {
            url: `${NotificationEndpoints.getUrl()}/check/all`,
            method: "post",
            query: {
                type: type ? type: undefined
            }
        };

    }

    static checkNotification(id){
        return {
            url: `${NotificationEndpoints.getUrl()}/${id}/check`,
            method: 'post'
        };
    }

    static uncheckNotification(id){
        return {
            url: `${NotificationEndpoints.getUrl()}/${id}/uncheck`,
            method: 'post'
        };
    }

}

/**
 * Administrators API Endpoints
 */
class AdminEndpoints {

    static  getUrl(){
        return '/api/admin';
    }

    static  get(id){
        return {
            url : AdminEndpoints.getUrl(),
            get: id
        };
    }

    static update(id , payload ){
        return{
            url: AdminEndpoints.getUrl(),
            update: id,
            content : payload
        };
    }

    static setDepartments(id,departmentList){
        return {
            url: `${AdminEndpoints.getUrl()}/${id}/departments`,
            method: "put",
            content: departmentList
        };
    }
}


class TicketsEndpoints{


    static getUrl(){
        return "/api/users/tickets";
    }

    static get(id){

        return {
            url: `${TicketsEndpoints.getUrl()}/${id}`,
            method: "get"
        };

    }

    static getMessages(id){

        return {
            url: `${TicketsEndpoints.getUrl()}/${id}/messages`,
            method: "get"
        };

    }

    static cancel(id){

        return {
            url: `${TicketsEndpoints.getUrl()}/${id}/cancel`,
            method: "post"
        }

    }

    static complete(id){

        return {
            url: `${TicketsEndpoints.getUrl()}/${id}/complete`,
            method: "post"
        }
    }

    static submit(payload){

        return {
            url: TicketsEndpoints.getUrl(),
            content: payload,
            method: "post"
        };
    }

    static createMessage(id , payload){

        return {
            url: `${TicketsEndpoints.getUrl()}/${id}/messages`,
            method: "post",
            content: payload
        };

    }

    static rateTicket(id , rating){

        return {
            url: `${TicketsEndpoints.getUrl()}/${id}/rate`,
            content: {
                rating: rating
            },
            method: "post"
        }
    }
}

class FeedbackEndpoints{

    static getUrl(){
        return "/api/users/feedback";
    }

    static getFeedBacks(){

        return {
            url: FeedbackEndpoints.getUrl(),
            method: "get"
        };

    }

    static submitFeedback(content){

        return {
            url: FeedbackEndpoints.getUrl(),
            method: "post",
            content: content
        };

    }

    static get(id){
        return {
            url: FeedbackEndpoints.getUrl(),
            get: id
        }
    }

}

/**
 * FBO API Endpoints
 */
class FBOEndpoints {

    static getUrl(){
        return '/api/fbo';
    }

    static  get(id){
        return {
           url : FBOEndpoints.getUrl(),
           get: id
        };
    }

    static getFBOFarmers(fboId){
        return {
            url: `${FBOEndpoints.getUrl()}/${fboId}/farmers`,
            method: 'get'
        };
    }


    static clearFarmers(fboId){

        return {
            url : `${FBOEndpoints.getUrl()}/${fboId}/clear-farmers`,
            method: 'delete'
        };

    }

    static hasFarmers(fboId){
        return {
            url : `${FBOEndpoints.getUrl()}/${fboId}/has-farmers`,
            method: 'get'
        };
    }

    static addFarmer(fboId , farmerId){

        return{
            url: `${FBOEndpoints.getUrl()}/${fboId}/add-farmer/${farmerId}`,
            method: 'put'
        }
    }

    static setDefault(fboId){

        return{
            url: `${FBOEndpoints.getUrl()}/${fboId}/set/default`,
            method: 'put'
        }

    }

    static update(fboId , payload ){

        return{
            url: FBOEndpoints.getUrl(),
            update: fboId,
            content : payload
        };
    }

    static deleteFBO(fboId){

        return {
            url: FBOEndpoints.getUrl(),
            delete: fboId
        };
    }

    static getRequests(id){

        return {
            url: `${FBOEndpoints.getUrl()}/${id}/farmers/requests`,
            method: "get"
        }
    }

    static  getRequestStats(id,timeFrame,range,step){

        return {
            url : `${FBOEndpoints.getUrl()}/${id}/requests/create/stats`,
            query: {
                'time_frame': timeFrame,
                'time_range': `${range.min},${range.max}`,
                'step': step
            },
            method:'get'
        };
    }

    static getFarmerCreateStats(id, timeFrame , range , step){

        return {
            url : `${FBOEndpoints.getUrl()}/${id}/farmers/create/stats`,
            query: {
                'time_frame': timeFrame,
                'time_range': `${range.min},${range.max}`,
                'step': step
            },
            method:'get'
        };
    }

    static exportCSV(filtered = true){
        return {
            url: `${FBOEndpoints.getUrl()}/export/csv${filtered ? '/filtered' : ''}`,
            method: "get"
        }
    }

}

/**
 * Media API Endpoints
 */
class MediaEndpoints {

    static getUrl(){
        return '/api/media';
    }

    static get(entity,id , tag){
        return {
            url : `${MediaEndpoints.getUrl()}/${id}/${entity}`,
            method: 'get',
            headers:tag ? {
                'x-media-tag': tag
            } : undefined
        }
    }

    static checkExists(entity,id){

        return {
            url: `${MediaEndpoints.getUrl()}/exists/${id}/${entity}`,
            method:'get'
        };
    }

    static createMedia(entity,id,file ,content , tag){

        return {
            url: `${MediaEndpoints.getUrl()}/${id}/${entity}`,
            method: 'post',
            type: file.type,
            headers: {
                'x-media-tag': tag
            },
            content: content
        };

    }

    static  updateMedia(entity,id ,tag , file , content  ){

        return {
            url : `${MediaEndpoints.getUrl()}/${id}/${entity}`,
            type: file.type,
            headers: {
                 'x-media-tag' : tag
            },
            method: 'put',
            content: content
        };
    }

    static deleteMedia(entity,id , tag , category = 0 ){
        return {
            url: `${MediaEndpoints.getUrl()}/${id}/${entity}`,
            method: 'delete',
            headers: {
                'x-media-tag' : tag,
                'x-media-category': category
            }
        };
    }

}

class TrackerEndpoints{


    static getUrl(){
        return '/api/trackers';
    }

    static getAll(simple,type){

        return {
            url: TrackerEndpoints.getUrl(),
            method: "get",
            query: {
                simple: simple,
                type: type
            }
        };

    }


    static getAllSimple(type){

        return {
            url: `${TrackerEndpoints.getUrl()}/simple`,
            method: "get",
            query:{
                type: type
            }
        };

    }

    static getAllList(condition, type){

        return {
            url: `${TrackerEndpoints.getUrl()}/list`,
            method: "get",
            query:{
                status: condition,
                type: type
            }
        };

    }

    static getUnmappedDevices(){

        return {
           url: `${TrackerEndpoints.getUrl()}/unmapped/devices`,
           method: "get"
        };
    }

    static getMappedDevices(){

        return {
            url: `${TrackerEndpoints.getUrl()}/mapped/devices`,
            method: "get"
        };

    }


    static  getTrackersLocation(){

        return {
            url : `${TrackerEndpoints.getUrl()}/location`,
            method: "get"
        };
    }

    static getTracker(id,simple){

        return {
            url: `${TrackerEndpoints.getUrl()}/${id}/tracker`,
            method: "get",
            query:{
                simple: simple
            }
        };

    }

    static getTrackerLocation(id){

        return {
            url: `${TrackerEndpoints.getUrl()}/${id}/location`,
            method: "get"
        };

    }

    static getTrackerLocationHistory(id,opts){

        return {
            url: `${TrackerEndpoints.getUrl()}/${id}/history/location`,
            method: "get",
            query: {
                start: opts.start,
                end: opts.end
            }
        };

    }

    static getTrackerGeofences(trackerId){

        return {
            url: `${TrackerEndpoints.getUrl()}/geofence`,
            method: "get"
        };
    }

    static getTrackerGeofence(trackerId , fenceId){
        return {
            url: `${TrackerEndpoints.getUrl()}/${trackerId}/geofence/${fenceId}`,
            method: "get"
        };
    }

    static createGeofence(trackerId, payload){
        return {
            url: `${TrackerEndpoints.getUrl()}/${trackerId}/geofence`,
            method: "post",
            content: payload
        };
    }

    static sendCommand(trackerId ,cmd ,value){

        return {
            url: `${TrackerEndpoints.getUrl()}/${trackerId}/command/${cmd}/${value}`,
            method: "post"
        };

    }

    static sendKnownCommand(trackerId, command){

        return {
            url: `${TrackerEndpoints.getUrl()}/${trackerId}/known-commands/${command}`,
            method: "post"
        };

    }

    static getTrackerCommands(trackerId){

        return {
            url: `${TrackerEndpoints.getUrl()}/commands`,
            method: "get"
        };

    }

    static enableGeofence(trackerId,fenceId){

        return {
            url: `${TrackerEndpoints.getUrl()}/${trackerId}/geofence/${fenceId}/enable`,
            method: "put"
        };

    }

    static disableGeofence(trackerId,  fenceId){

        return {
            url: `${TrackerEndpoints.getUrl()}/${trackerId}/geofence/${fenceId}/disable`,
            method: "put"
        };

    }

    static installTracker(tractorId,payload){

        return {
            url: `${TrackerEndpoints.getUrl()}/${tractorId}`,
            method: "post",
            content: payload
        };

    }


    static updateTracker(trackerId,payload){

        return {
            url: `${TrackerEndpoints.getUrl()}/${trackerId}`,
            content: payload,
            method: "put"
        };

    }

    static removeTracker(trackerId){
        return {
            url: `${TrackerEndpoints.getUrl()}/${trackerId}`,
            method: "delete"
        }
    }


    static exportCSV(filtered = true){

        return {
            url: `${TrackerEndpoints.getUrl()}/export/csv${filtered ? '/filtered' : '' }`,
            method: "get"
        };

    }
}

/**
 * Tractors API Endpoints
 */
class TractorsEndpoints {

    static  getUrl(){
        return '/api/tractors';
    }

    static exportCSV(filtered = true){
        return {
            url: `${TractorsEndpoints.getUrl()}/export/csv${filtered ? '/filtered' : '' }`,
            method: "get"
        }
    }

    /**
     * opts.action The action to suggestion is going to be used for
     * opts.center.lat The center reference latitude point
     * opts.center.lng The center reference longitude point
     * opts.allowInactiveOwners Include tractors for tractor owners with disabled accounts
     * opts.includeAssignedTractors Controls whether currently assigned tractor are to be part of the response
     * opts.hasTrackerOnly Include only tractors with trackers
     * opts.useGPS Use and include the GPS state (real time positioning)
     * opts.maxResults The maximum expected results
     * opts.selectTractors A list of tractors to pick from
     * @param opts
     */
    static suggestTractors(opts){

        return {
            url : `${TractorsEndpoints.getUrl()}/suggest/${opts.action}`,
            method: 'get',
            query:{
                lat: opts.center.lat,
                lng: opts.center.lng,
                include_inactive_owners: opts.allowInactiveOwners,
                include_assigned_tractors: opts.includeAssignedTractors,
                has_tracker: opts.hasTrackerOnly,
                gps_state: opts.useGPS,
                maxResults: opts.maxResults,
                request_id: opts.request_id
            },
            headers:{
                'x-tractors': opts.selectTractors || undefined
            }
        };

    }

    static get(id){
        return {
            url : `${TractorsEndpoints.getUrl()}`,
            get: id
        };
    }

    static  getActiveTractors(){
        return {
            url: `${TractorsEndpoints.getUrl()}/state/active`,
            method: 'get'
        };
    }

    static  getFaultedTractors(){
        return{
            url: `${TractorsEndpoints.getUrl()}/state/faulted`,
            method: 'get'
        }
    }

    static checkAvailability(service,province,district,ward){

        return {
            url: `${TractorsEndpoints.getUrl()}/check/availability`,
            method: "get",
            query: {
                service: service ? service : undefined,
                province: province ? province : undefined,
                district: district ? district : undefined,
                ward: ward ? ward : undefined
            }
        };

    }

    static getTractorStats(){
        return {
            url: `${TractorsEndpoints.getUrl()}/stats`,
            method: 'get'
        }
    }

    static getAssignedOwner(id){
        return {
            url: `${TractorsEndpoints.getUrl()}/${id}/owner`,
            method: 'get'
        };
    }

    static getAssignmentRules(id){

        return {
            url: `${TractorsEndpoints.getUrl()}/${id}/assignment_rules`,
            method: "get"
        }

    }

    static updateAssignmentRules(id,rules){

        return {
            url: `${TractorsEndpoints.getUrl()}/${id}/assignment_rules`,
            method: "put",
            content: rules
        };

    }

    static getAssignedRequests(id){
        return {
            url: `${TractorsEndpoints.getUrl()}/${id}/requests`,
            method: 'get'
        };
    }

    static getAssignedOperator(id){
        return{
            url : `${TractorsEndpoints.getUrl()}/${id}/operator`,
            method: 'get'
        };
    }

    static  create(ownerId,payload){
        return {
            url: `${TractorsEndpoints.getUrl()}/${ownerId}/owner`,
            method: 'post',
            content: payload
        }
    }

    static update(id,payload){

        return {
            url: TractorsEndpoints.getUrl(),
            update: id,
            content: payload
        };
    }

    static getTracker(id){

        return {
            url: `${TractorsEndpoints.getUrl()}/${id}/tracker`,
            method: "get"
        };

    }

    static getInActiveTractors(){
        return {
            url: `${TractorsEndpoints.getUrl()}/state/faulted`,
            method: "get"
        }
    }

    static getOperationSummary(id,range,custom){

        return {
            url: `${TractorsEndpoints.getUrl()}/${id}/operation/summary`,
            method: "get",
            query: {
                'from': custom ? custom.from : undefined,
                'to': custom? custom.to : undefined,
                'range': range
            }
        };

    }

    static assignOwner(ownerId,tractorId){
        return{
            url: `${TractorsEndpoints.getUrl()}/${tractorId}/assign-owner/${tractorId}`,
            method: 'put'
        };
    }

    static  deleteTractor(tractorId){
        return {
            url : TractorsEndpoints.getUrl(),
            delete: tractorId
        };
    }

}


class PermissionsEndpoint {


    static getUrl(){
        return "api/permissions";
    }

    static getAll(){
        return {
            url: PermissionsEndpoint.getUrl(),
            method: "get"
        };
    }

    static get(id){
        return {
            url: `${PermissionsEndpoint.getUrl()}/${id}`,
            method: "get"
        };
    }

    static getForUserRole(role){

        return {
            url: `${PermissionsEndpoint.getUrl()}/role/${role}`,
            method: "get"
        };

    }

    static setUserPermissions(userId, permissions){
        return {
            url: `${PermissionsEndpoint.getUrl()}/${userId}/set`,
            method: "put",
            content: {
                permissions
            }
        };
    }


    static grantPermission(userId , permission){

        return {
            url: `${PermissionsEndpoint.getUrl()}/${userId}/grant/${permission}`,
            method: "post"
        };

    }

    static revokePermission(userId, permission){

        return {
            url: `${PermissionsEndpoint.getUrl()}/${userId}/revoke/${permission}`,
            method: "post"
        };
    }

}

class  AuditEndpoints {

    static getUrl(){
        return "api/audit"
    }

    static getAll(query){
        return {
            url: AuditEndpoints.getUrl(),
            method: "get",
            query
        };
    }

    static  getForUser(userId){
        return {
            url: `${AuditEndpoints.getUrl()}/${userId}/user`,
            method: "get"
        };
    }
}

/**
 * Tractor Owners API Endpoints
 */
class TractorOwnerEndpoints {

    static getUrl(){
        return '/api/tractor_owners';
    }

    static get(id){
        return {
            url: TractorOwnerEndpoints.getUrl(),
            get: id
        }
    }

    static  deleteTractorOwner(id){
        return {
            url: TractorOwnerEndpoints.getUrl(),
            delete: id
        };
    }

    static getTractors(ownerId){
        return{
            url: `${TractorOwnerEndpoints.getUrl()}/${ownerId}/tractors`,
            method:'get'
        }
    }

    static getRequests(ownerId){
        return {
            url: `${TractorOwnerEndpoints.getUrl()}/${ownerId}/requests`,
            method: 'get'
        }
    }

    static getOperators(ownerId){
        return {
            url: `${TractorOwnerEndpoints.getUrl()}/${ownerId}/operators`,
            method: 'get'
        }
    }

    static transferOwnership(ownerId, entity, id){
        return {
            url: `${TractorOwnerEndpoints.getUrl()}/${ownerId}/transfer/${id}/${entity}`,
            method: "post"
        }
    }

    static  getAcreageStats(ownerId , timeFrame, range , step ){
        return {
            url : `${TractorOwnerEndpoints.getUrl()}/${ownerId}/stats/acreage`,
            method: 'get',
            query: {
                'time_frame': timeFrame,
                'time_range': `${range.min},${range.max}`,
                'step': step
            }
        };
    }

    static  updateOwner(ownerId,payload){
        return {
            url: TractorOwnerEndpoints.getUrl(),
            update: ownerId,
            content: payload
        };
    }

    static exportCSV(filtered = true){
        return {
            url: `${TractorOwnerEndpoints.getUrl()}/export/csv${filtered ? '/filtered' : '' }`,
            method: "get"
        }
    }

}

/**
 * Tractor Requests Endpoint API
 */
class TractorRequestEndpoints {

    static getUrl(){
        return '/api/tractor_requests';
    }

    static get(id){
        return {
            url : `${TractorRequestEndpoints.getUrl()}/${id}`,
            get: id
        };
    }

    static  getStats(timeFrame, range , step ){

        return {
            url : `${TractorRequestEndpoints.getUrl()}/stats`,
            query: {
                'time_frame': timeFrame,
                'time_range': `${range.min},${range.max}`,
                'step': step
            },
            method:'get'
        };
    }

    static getService(id){
        return {
            url: `${TractorRequestEndpoints.getUrl()}/${id}/service`,
            method: "get"
        };
    }

    static getOperationSummary(){

        return {
            url: `${TractorRequestEndpoints.getUrl()}/operation/summary`,
            method: "get"
        };

    }

    static getOwnerOperationSummary(id){

        return {
            url: `${TractorRequestEndpoints.getUrl()}/operation/summary/${id}/owner`,
            method: "get"
        };

    }

    static getFarmerOperationSummary(id){

        return {
            url: `${TractorRequestEndpoints.getUrl()}/operation/summary/${id}/farmer`,
            method: "get"
        };

    }

    static getFBOOperationSummary(id){

        return {
            url: `${TractorRequestEndpoints.getUrl()}/operation/summary/${id}/fbo`,
            method: "get"
        };

    }

    /**
     * Retry last failed transaction
     * @param id
     */
    static retryLastTransaction(id){

        return {
            url: `${TractorRequestEndpoints.getUrl()}/${id}/retry/transaction/last`,
            method: "post"
        }

    }

    static getAssignedTractor(id){
        return {
            url:`${TractorRequestEndpoints.getUrl()}/${id}/tractor`,
            method: 'get'
        };
    }

    static getAssignedOperator(id){
        return {
            url: `${TractorRequestEndpoints.getUrl()}/${id}/operator`,
            method: 'get'
        };
    }

    static  getAssignedOwner(id){
        return {
            url: `${TractorRequestEndpoints.getUrl()}/${id}/owner`,
            method: 'get'
        }
    }


    static getRequestsInState(state){

        return {
            url: `${TractorRequestEndpoints.getUrl()}/get-state/${state}`,
            method: 'get'
        };

    }

    static rateRequest(id,rating){

        return {
            url: `${TractorRequestEndpoints.getUrl()}/${id}/rate/${rating}`,
            method: "post"
        };

    }

    static createTractorRequest(serviceId,payload,token,fboId,initializeTransaction){

        return {
            url: `${TractorRequestEndpoints.getUrl()}/register/${serviceId}`,
            method: 'post',
            content: payload,
            query: {
                fbo: fboId
            },
            headers:{
                'x-token': token,
                'x-no-transaction': !initializeTransaction,
            }
        };

    }

    static assignTractorRequest(id,tractor,location,comments){

        return {
            url: `${TractorRequestEndpoints.getUrl()}/${id}/assign-request/${tractor}/tractor`,
            method: 'put',
            headers:{
                'x-location-override': location ? [ location.location || location.place || location.text ,location.lat,location.lng].join(":") : undefined
            },
            content:{
                comments,
            },
            query:{
                'binder' : 'admin'
            }
        };

    }

    static completeRequest(id,comments){

        return {
             url : `${TractorRequestEndpoints.getUrl()}/${id}/complete-request`,
             method: 'put',
            content: {
                 comments
            }
        };

    }

    static deleteRequest(id){
        return{
            url : TractorRequestEndpoints.getUrl(),
            delete: id
        };
    }

    static releaseRequest(id,opts){

        return {
            url : `${TractorRequestEndpoints.getUrl()}/${id}/release`,
            query:{
                refund: opts.refund
            },
            content:{
                amount: opts.refundAmount,
                fullRefund: opts.fullRefund,
                comments: opts.comments
            },
            method: 'delete'
        };
    }

    static update(id,payload){
        return {
            url: TractorRequestEndpoints.getUrl(),
            update: id,
            content: payload
        };
    }

    static getPayStatus(id){

        return {
            url: `${TractorRequestEndpoints.getUrl()}/pay/status`,
            query:{
                id: id
            },
            method: "get"
        };

    }

    static calculateRequestCost(serviceId,quantity,pricingGroup,pricingId){

        return {
            url: `${TractorRequestEndpoints.getUrl()}/calculate/cost`,
            content: {
                service_id: serviceId,
                amount: quantity,
                pricing_group: pricingGroup,
                pricing_id: pricingId,
                apply_discount: false
            },
            method: "post"
        }
    }

    static getRequestMessages(id){

        return {
            url: `${TractorRequestEndpoints.getUrl()}/${id}/messages/all`,
            method: "get"
        };

    }

    static getRequestMessage(requestId, messageId){

        return {
            url: `${TractorRequestEndpoints.getUrl()}/${requestId}/messages/${messageId}`,
            method: "get"
        };

    }

    static createRequestMessage(id,payload){

        return {
            url: `${TractorRequestEndpoints.getUrl()}/${id}/messages/create`,
            method: "post",
            content: payload
        };

    }

    static exportCSV(filtered = true){
        return {
            url: `${TractorRequestEndpoints.getUrl()}/export/csv${filtered ? '/filtered' : ''}`,
            method: "get"
        }
    }



}

/**
 * Tractor Operators Endpoint API
 */
class TractorOperatorEndpoint{

    static getUrl(){
        return '/api/operator';
    }

    static exportCSV(filtered = true){
        return {
            url: `${TractorOperatorEndpoint.getUrl()}/export/csv${filtered ? '/filtered' : ''}`,
            method: "get"
        }
    }

    static getId(id){
        return {
            url: TractorOperatorEndpoint.getUrl(),
            get: id
        };
    }

    static getOperatorOwner(id){
        return {
            url : `${TractorOperatorEndpoint.getUrl()}/${id}/owner`,
            method:'get'
        };
    }

    static getOperatorTractor(id){
        return {
            url : `${TractorOperatorEndpoint.getUrl()}/${id}/tractor`,
            method:'get'
        };
    }

    static  getRequests(id){
        return {
            url: `${TractorOperatorEndpoint.getUrl()}/${id}/requests`,
            method: 'get'
        }
    }

    static setOwner(operatorId , ownerId){
        return{
            url : `${TractorOperatorEndpoint.getUrl()}/${operatorId}/assign-owner/${ownerId}`,
            method: 'put'
        };
    }

    static assignTractor(operatorId , tractorId){
        return {
            url : `${TractorOperatorEndpoint.getUrl()}/${operatorId}/assign-tractor/${tractorId}`,
            method: 'put'
        };
    }


    static updateOperator(id , payload){
        return {
            url : TractorOperatorEndpoint.getUrl(),
            update: id,
            content: payload
        }
    }

    static createOperator(ownerId , tractorId , payload ){

        let url;
        if(tractorId){
            url = `${TractorOperatorEndpoint.getUrl()}/${ownerId}/owner/${tractorId}/tractor`;
        }else{
            url = `${TractorOperatorEndpoint.getUrl()}/${ownerId}/owner`;
        }

        return {
            url : url,
            method: 'post',
            content: payload
        };
    }

    static checkOperatorRequest(id){

        return {
            url: `${TractorOperatorEndpoint.getUrl()}/check/request/${id}`,
            method: "post"
        };

    }

    static deleteOperator(id){
        return {
            url: TractorOperatorEndpoint.getUrl(),
            delete: id
        };

    }

    static getOperationSummary(id,range,custom){

        return {
           url: `${TractorOperatorEndpoint.getUrl()}/${id}/operation/summary`,
           method: "get",
           query: {
               'from': custom ? custom.from : undefined,
               'to': custom? custom.to : undefined,
               'range': range
           }
        };
    }

    static releaseTractor(id){
        return {
           url : `${TractorOperatorEndpoint.getUrl()}/${id}/tractor`,
           method: 'delete'
        };
    }

    static getUSSDRegistered(){

        return {
            url: `${TractorOperatorEndpoint.getUrl()}/registered`,
            method: "get"
        };

    }

    static getRatings(id){

        return {
            url: `${TractorOperatorEndpoint.getUrl()}/${id}/rating`,
            method:"get"
        }
    }

}

class AnalyticsEndpoints{

    static  getUrl(){
        return '/api/analytics';
    }

    static getCreateStats(entities , timeFrame , range , step ){
        return {
            url : `${AnalyticsEndpoints.getUrl()}/create/stats`,
            method: 'get',
            query: {
                'time_frame': timeFrame,
                'time_range': `${range.min},${range.max}`,
                'step': step,
                'entity': entities
            }
        };
    }

}

/**
 * Transactions API Endpoints
 */
class TransactionsEndpoints {

    static  getUrl(){
        return '/api/transactions';
    }

    static get(id){
        return {
            url: `${TransactionsEndpoints.getUrl()}`,
            get: id
        };
    }

    static getSummary(){

        return {
            url : `${TransactionsEndpoints.getUrl()}/summary`,
            method: 'get'
        };

    }

    static generateIncomeFlowChart(timeFrame,range,step = 1){

        return {
            url : `${TransactionsEndpoints.getUrl()}/flow/success/chart`,
            method: 'get',
            query: {
                'time_frame': timeFrame,
                'time_range': `${range.min},${range.max}`,
                'step': step,
            }
        };
    }

    static getSegmentedIncomeStats(range){

        const url = `${TransactionsEndpoints.getUrl()}/segmented/income`;
        switch (typeof range){
            case "string":{

                return {
                    url: url,
                    method: "get",
                    query:{
                        range: range
                    }
                };

            }
            case "object": {

                return {
                    url: url,
                    method: "get",
                    query: {
                        from: range.from,
                        to: range.to
                    }
                };
            }
            case "undefined":{
                return {
                    url: url,
                    method: "get"
                }
            }
        }
    }

    static exportCSV(filtered = true){

        return {
            url: `${TransactionsEndpoints.getUrl()}/export/csv${filtered? '/filtered' : ''}`,
            method: "get"
        }

    }

}

/**
 * TTL-GEO Data API
 */
class GeoEndpoints {

    static getUrl(){
        return '/api/geo';
    }


}


/**
 * Users API Endpoints
 */
class  UsersEndpoints {


    static  getUrl(){
        return '/api/users';
    }


    static getByRole(role){
        return{
            url: `${UsersEndpoints.getUrl()}/${role}/role`,
            method: 'get'
        };
    }

    static getActivitySummary(){
        return {
            url: `${UsersEndpoints.getUrl()}/activity/summary`,
            method: 'get'
        };
    }

    static get(id){
        return {
            url: `${UsersEndpoints.getUrl()}/${id}`,
            method: "get"
        };
    }

    /**
     * Login user
     * @param credentials
     */
    static login(credentials){
        return {
            url: "/auth/local",
            method: 'post',
            content: credentials,
            noAuth: true
        }
    }




    /**
     * Login test. For checking the number of account associated for user
     * @param credentials
     */
    static testLogin(credentials){

        return {
            url: "/auth/local/test",
            method: "post",
            content: credentials,
            noAuth: true
        };
    }

   static  confirmPhone(phone){
        return {
            url: `${UsersEndpoints.getUrl()}/confirm/phone`,
            content:{
                phone: phone
            },
            method: 'post'
        };
    }

    static confirmEmail(email){
        return{
            url: `${UsersEndpoints.getUrl()}/confirm/email`,
            content:{
                email: email
            },
            method:'post'
        }
    }

    static changeEmail(token,email){

        return {
           url: `${UsersEndpoints.getUrl()}/changeemail`,
           method:'post',
           content:{
               token: token,
               email: email
           }
        };
    }

    static changePhone(token,phone){
        return {
            url: `${UsersEndpoints.getUrl()}/changephone`,
            method: 'post',
            content:{
                token: token,
                phone: phone
            }
        };
    }

    static getMyself(){

        return{
            url: `${UsersEndpoints.getUrl()}/me`,
            method: 'get'
        }
    }

    static getAssociatedEntity(userId){

        return {
            url : `${UsersEndpoints.getUrl()}/${userId}/assoc-entity`,
            method: 'get'
        };
    }

    static  changePassword(oldPassword , newPassword , confirmPassword ){
        return {
            url : `${UsersEndpoints.getUrl()}/password`,
            method: 'put',
            content: {
                oldpassword: oldPassword,
                newpassword: newPassword,
                confirmpassword: confirmPassword
            }
        };
    }

    /**
     * Log user out
     * @returns {{url: string, method: string}}
     */
    static signOut(){
        return {
           url : `${UsersEndpoints.getUrl()}/logout`,
           method: 'post'
        };
    }

    static logout(){
        return {
            url : `${UsersEndpoints.getUrl()}/logout`,
            method: 'post'
        };
    }

    static updateUser(userId , payload){
        return {
            url: `${UsersEndpoints.getUrl()}`,
            update: userId,
            content: payload
        };
    }

    static forgotPassword( input ){
        return {
            url : `${UsersEndpoints.getUrl()}/forgotpassword`,
            content: {input: input },
            method: 'post',
            noAuth: true
        }
    }

    static activateAccount(token,identity){
        return {
            url: `${UsersEndpoints.getUrl()}/activate`,
            method: 'post',
            headers:{
                'x-token': token,
                'x-identity': identity
            },
            noAuth: true
        }
    }

    static completePasswordReset( identity ,  token , newPassword ){
        return {
            url : `${UsersEndpoints.getUrl()}/resetpassword`,
            query: {
                'token': token
            },
            headers:{
              'x-identity' : identity
            },
            content: {
                password: newPassword
            },
            method: 'post',
            noAuth: true
        };
    }

    static adminLockUserAccount(userId){

        return {
            url: `${UsersEndpoints.getUrl()}/admin/lock/${userId}`,
            method: 'post'
        };

    }

    static  adminActivateAccount(userId, method = "sms"){
        return {
            url: `${UsersEndpoints.getUrl()}/admin/activate/${userId}`,
            method: 'put',
            query: {
                method: method
            }
        }
    }

    static adminResetPassword(userId,method = "sms"){
        return {
            url : `${UsersEndpoints.getUrl()}/admin/resetpassword/${userId}`,
            method: 'post',
            query: {
                method: method
            }
        }
    }

    static adminUnlockAccount(userId){
        return {
            url: `${UsersEndpoints.getUrl()}/admin/unlock/${userId}`,
            method: 'put'
        };
    }

    static beginActivateMyEmail(){

        return {
            url: `${UsersEndpoints.getUrl()}/activate/email`,
            method: "post"
        };

    }

    static completeActivateMyEmail(token){

        return {
            url: `${UsersEndpoints.getUrl()}/complete/email/activation`,
            method: "post",
            content: {
                token: token
            }
        };
    }

    /**
     * Override user active notifications
     */
    static overrideUserActiveNotifications(id,notifications){

        return {
            url: `${UsersEndpoints.getUrl()}/${id}/active/notification/override`,
            content: {
                notifications: notifications
            },
            method: "post"
        };

    }


    static beginActivation(method , identityOrUserId ){

        if(isFinite(identityOrUserId)){
            return {
                url: `${UsersEndpoints.getUrl()}/activate/${identityOrUserId}/${method}`,
                method: 'put',
                noAuth: true
            };
        }
        else{
            return {
                 url: `${UsersEndpoints.getUrl()}/activate/${method}`,
                 method :'put',
                 headers: {
                     'x-identity' : identityOrUserId
                 },
                 noAuth: true
            };
        }
    }

    static registerUserAccount(entity,verify,confirm,payload){

        return {
            url: `api/users/${entity}`,
            method: 'post',
            content: payload,
            verify: verify,
            headers:{
                'x-no-activation': !confirm
            },
            noAuth: entity !== "admin",
        };

    }

    static registerTractorOwnerAccount(verify,confirm,payload){
        return UsersEndpoints.registerUserAccount('owner',verify,confirm,payload);
    }

    static registerFBOAccount(verify,confirm,payload){
        return UsersEndpoints.registerUserAccount('fbo',verify,confirm,payload);
    }

    static registerFarmerAccount(verify,confirm,payload){
        return UsersEndpoints.registerUserAccount('farmer',verify,confirm,payload);
    }
}


class USSDEndpoints{

    static getUrl(){
        return '/api/ussd';
    }

    static createUSSDService(payload){

        return {
            url: `${USSDEndpoints.getUrl()}/services`,
            method: 'post',
            content: payload
        };

    }

    static getUSSDServices(){
        return {
            url: `${USSDEndpoints.getUrl()}/services`,
            method: 'get'
        };
    }

    static getUSSDService(id){
        return {
            url: `${USSDEndpoints.getUrl()}/services/${id}`,
            method: "get"
        };
    }

    static updateUSSDService(id,payload){
        return{
            url: `${USSDEndpoints.getUrl()}/services`,
            update: id,
            content: payload
        };
    }

    static updateServiceBinding(id,payload){

        return {
            url: `${USSDEndpoints.getUrl()}/services/binding/${id}`,
            method: "put",
            content: payload
        }
    }

    static removeServiceBinding(id){

        return {
            url: `${USSDEndpoints.getUrl()}/services/binding/${id}/remove`,
            method: 'delete'
        }

    }

    static createServiceBinding(serviceId,payload){

        return {
            url: `${USSDEndpoints.getUrl()}/services/${serviceId}/binding/create`,
            method: "post",
            content: payload
        };

    }

    static deleteUSSDService(id){

        return {
            url: `${USSDEndpoints.getUrl()}/services`,
            delete: id
        };

    }

}

/**
 * Misc API Endpoints
 */
class MiscEndpoints {

    static  getUrl(){
        return '/api/misc';
    }

    static getAdminDashboardStats(){
        return {
            url: `${MiscEndpoints.getUrl()}/dashboard/admin/stats`,
            method: 'get'
        }
    }

    static getSettings(){
        return {
            url: `${MiscEndpoints.getUrl()}/settings`,
            method: 'get'
        };
    }

    static createSetting(payload){
        return {
           url: `${MiscEndpoints.getUrl()}/settings`,
           method: 'post',
           content: payload
        };
    }

   static getSetting(id,category = 'default'){
        return {
            url: `${MiscEndpoints.getUrl()}/settings/${id}`,
            method: 'get',
            query:{
                category: category
            }
        };
    }

    static getSettingWithName(name,category='default'){
        return {
            url: `${MiscEndpoints.getUrl()}/settings/${name}/name`,
            method: 'get',
            query:{
                category: category
            }
        };
    }

    static updateSetting(id,payload){

        return {
            url: `${MiscEndpoints.getUrl()}/settings/${id}`,
            method: 'put',
            content: payload
        };
    }

    static getOwnerDashboardStats(ownerId){
        return {
            url : `${MiscEndpoints.getUrl()}/dashboard/owner/${ownerId}/stats`,
            method:'get'
        }
    }

    static getFarmerDashboardStats(farmerId){
        return {
            url: `${MiscEndpoints.getUrl()}/dashboard/farmer/${farmerId}/stats`,
            method: "get"
        }
    }

    static getFBODashboardStats(fboId){
        return {
            url : `${MiscEndpoints.getUrl()}/dashboard/fbo/${fboId}/stats`,
            method: 'get'
        }
    }

    static getOwnerTractorRelations(includeTractors = true ){

        return {
            url: `${MiscEndpoints.getUrl()}/owner-tractor/rel/stats`,
            method: 'get',
            query:{
                'include_tractors': includeTractors
            }
        }
    }

    static getFBOFarmerRelations(includeFarmers = true) {

        return {
            url: `${MiscEndpoints.getUrl()}/fbo-farmer/rel/stats`,
            method: 'get',
            query:{
                'include_farmers': includeFarmers
            }
        };

    }

    static resolveCoordinates(coord){

        return {
            url: `${MiscEndpoints.getUrl()}/location/address`,
            method: "post",
            content: coord
        };
    }

    static guessLocations(keyword){

        return {
            url: `${MiscEndpoints.getUrl()}/location/guess`,
            query: {
                keyword: keyword
            }
        };

    }

    static getPricingGroups(){
        return{
            url: `${MiscEndpoints.getUrl()}/pricing/groups`,
            method: "get"
        }
    }

    static createPricingGroup(payload){
        return {
            url: `${MiscEndpoints.getUrl()}/pricing/groups`,
            content: payload,
            method: "post"
        }
    }

    static updatePricingGroup(id,payload){
        return {
            url: `${MiscEndpoints.getUrl()}/pricing/groups/${id}`,
            content: payload,
            method: "put"
        }
    }

    static getActiveNotificationList(roles){

        return {
            url: `${MiscEndpoints.getUrl()}/all/notifications`,
            query: {
                roles
            },
            method: "get"
        };
    }


    /**
     * List all locations
     */
    static listAllLocations(province,district){

        return {
            url: `${MiscEndpoints.getUrl()}/list/location/district/province/all`,
            method: 'get',
            json: true,
            query: {
                province,
                district
            }
        };
    }


}


/**
 * Payments endpoints
 */
class PaymentsEndpoints {

    static getUrl(){
        return "api/payments";
    }

    static get(id){

        return {
            url: `${PaymentsEndpoints.getUrl()}/${id}`,
            method: "get"
        };

    }

    static getRequestPaymentInfo(id){

        return {
            url: `${PaymentsEndpoints.getUrl()}/request/${id}/info`,
            method: "get"
        }
    }

    static getOwnerRequests(id){

        return {
            url: `${PaymentsEndpoints.getUrl()}/${id}/owner/requests`,
            method: "get"
        };

    }

    static getOwnerPaymentInfo(id){

        return {
            url: `${PaymentsEndpoints.getUrl()}/owner/${id}/info`,
            method: "get"
        }
    }


    static acknowledgePayment(id){

        return {
            url: `${PaymentsEndpoints.getUrl()}/acknowledge/${id}`,
            method: "put"
        }

    }

    static makeBulkPayments(payments){

        return {
            url: `${PaymentsEndpoints.getUrl()}/bulk/create`,
            method: "post",
            content: {
                payments
            }
        }

    }


    static cancelPayment(id){

        return {
            url: `${PaymentsEndpoints.getUrl()}/cancel/${id}`,
            method: "put"
        };

    }

    static exportCSV(filtered = true){

        return {
            url: `${PaymentsEndpoints.getUrl()}/export/csv${filtered? '/filtered' : ''}`,
            method: "get"
        }

    }
}

class WalletEndpoints{

    static getUrl(){
        return "api/users/wallet";
    }

    static getMyWallets(){
        return {
            url: `${WalletEndpoints.getUrl()}`,
            method: "get"
        }
    }

    static getWalletsForUser(id){

        return {
            url: `${WalletEndpoints.getUrl()}/${id}`,
            method: "get"
        };

    }


    static createWallet(payload , userId){

        return {
            url: `${WalletEndpoints.getUrl()}${userId ? `/${userId}` : ''}`,
            method: "post",
            content: payload
        };

    }

    static updateWallet(id,payload){

        return {
            url: `${WalletEndpoints.getUrl()}/${id}`,
            method: "put",
            content: payload
        };

    }

    static setWalletDefault(id){

        return {
            url: `${WalletEndpoints.getUrl()}/set/default/${id}`,
            method: "post"
        };

    }

}


class VirtualCredit{

    static getUrl(){
        return '/api/ext/credit/virtual';
    }

    static getAllPayments(){

        return {
            url: `${VirtualCredit.getUrl()}/payments`,
            method: "get"
        };
    }

    static getPayment(id){

        return {
            url: `${VirtualCredit.getUrl()}/payments/${id}`,
            method: "get"
        }
    }

    static getVerificationUsers(id){

        return {
            url: `${VirtualCredit.getUrl()}/payments/${id}/verification/users`,
            method: "get"
        };

    }

    static getConsumers(id){

        return {
            url: `${VirtualCredit.getUrl()}/payments/${id}/consumers`,
            method: "get"
        };

    }


    static createPayment(payload){

        return {
            url: `${VirtualCredit.getUrl()}/payments`,
            method: "post",
            content: payload
        };

    }

    static enablePayment(id){

        return {
            url: `${VirtualCredit.getUrl()}/payments/enable/${id}`,
            method: "post"
        };
    }

    static disablePayment(id){

        return {
            url: `${VirtualCredit.getUrl()}/payments/disable/${id}`,
            method: "post"
        };

    }

    static getPaymentTransactions(id){

        return {
            url: `${VirtualCredit.getUrl()}/payments/${id}/transactions`,
            method: "get"
        };

    }

    static updateProperty(id,propertyName,value){

        return {
            url: `${VirtualCredit.getUrl()}/payments/${id}/${propertyName}`,
            content: {
                value
            },
            method: "put"
        };

    }

    static getPaymentTransaction(id){

        return {
            url: `${VirtualCredit.getUrl()}/payments/transaction/${id}`,
            method: "get"
        }

    }


    static confirmPayment(id) {

        return {
            url: `${VirtualCredit.getUrl()}/payments/${id}/confirm/verification`,
            method: "post"
        };

    }

    static addPaymentAmount(id,amount){

        return {
            url: `${VirtualCredit.getUrl()}/payments/${id}/add/amount`,
            method: "put",
            content: {
                amount
            }
        };

    }

    static addPaymentUSSDService(id,service){

        return {
            url: `${VirtualCredit.getUrl()}/payments/${id}/add/service/info`,
            method: "post",
            content: service
        }
    }

    static addPaymentConsumer(id,consumer){

        return {
            url: `${VirtualCredit.getUrl()}/payments/${id}/add/consumer`,
            method: "post",
            content: consumer
        };

    }

    static getPaymentTransactionForConsumer(paymentId,farmerId){

        return {
            url: `${VirtualCredit.getUrl()}/payments/${paymentId}/transactions/${farmerId}/consumer`,
            method: "get"
        }

    }

    static getPaymentChangesList(id){

        return {
            url: `${VirtualCredit.getUrl()}/payments/${id}/changes/list`,
            method: "get"
        };

    }

    static getPaymentConsumerChangesList(paymentId,farmerId){
        return {
            url: `${VirtualCredit.getUrl()}/payments/${paymentId}/changes/list/${farmerId}/consumer`,
            method: "get"
        };
    }

    static getConsumerTransactionSummary(paymentId,farmerId){

        return {
            url: `${VirtualCredit.getUrl()}/payments/${paymentId}/transactions/summary/${farmerId}/consumer`,
            method: "get"
        }

    }

    static getConsumerSpendChart(paymentId,farmerId,timeFrame,range,step = 1){

        return {
            url: `${VirtualCredit.getUrl()}/payments/${paymentId}/transactions/chart/${farmerId}/consumer`,
            method: 'get',
            query: {
                'time_frame': timeFrame,
                'time_range': [range.min,range.max,range.step].filter(x => !_.isNil(x)).join(','),
                'step': step,
            }
        };
    }

    static exportPaymentTransactions(id,filtered = true){

        return {
            url: `${VirtualCredit.getUrl()}/payments/${id}/transactions/export/csv${filtered? '/filtered' : ''}`,
            method: "get"
        }

    }

    static changeUSSDServiceStatus(id, enabled){

        return {
            url: `${VirtualCredit.getUrl()}/payments/${enabled ? 'enable' : 'disable'}/${id}/ussd/service`,
            method: "post"
        };

    }

    static changeConsumerStatus(id, enabled){

        return {
            url: `${VirtualCredit.getUrl()}/payments/${enabled ? 'enable' : 'disable'}/${id}/consumer`,
            method: "post"
        };

    }

    static queryFarmerStatus(farmerId){

        return {
            url: `${VirtualCredit.getUrl()}/${farmerId}/farmer/status`,
            method: "get"
        }
    }

    static queryFarmerStatusWithPhone(phone){

        return{
            url: `${VirtualCredit.getUrl()}/farmer/status`,
            method: "get",
            query: {
                phone
            }
        };
    }

    static changeVerificationUserStatus(id,enabled){

        return {
            url: `${VirtualCredit.getUrl()}/payments/${enabled ? 'enable' : 'disable'}/${id}/verification/user`,
            method: "post"
        };


    }

    static exportPaymentsCSV(filtered = true){

        return {
            url: `${VirtualCredit.getUrl()}/payments/export/csv${filtered? '/filtered' : ''}`,
            method: "get"
        }

    }

    static allocatePaymentConsumer(consumerId,payload){

        return {
            url: `${VirtualCredit.getUrl()}/payments/${consumerId}/consumer/allocate`,
            method: "post",
            content: payload
        };

    }

    static deallocatePaymentConsumer(consumerId,payload){

        return {
            url: `${VirtualCredit.getUrl()}/payments/${consumerId}/consumer/deallocate`,
            method: "post",
            content: payload
        };

    }
}

/**
 * Messages endpoints
 */
class MessagesEndpoints {

}

/**
 * Authentication endpoints
 */
class AuthEndpoints {

    static login(username,password,role){
        return {
            url: `/auth/local`,
            method: 'post',
            content: { username: username , password: password , role: role },
            noAuth: true
        };
    }

    static testLogin(username,password){
        return {
            url: `/auth/local/test`,
            method: 'post',
            content: { username: username , password: password },
            noAuth: true
        };
    }

    static refreshToken(userId , refreshToken){

        return {
            url: `/api/local/refresh/${userId}`,
            method: 'post',
            headers:{ 'x-refresh-token': refreshToken },
            noAuth: true
        };

    }
}


export {
    AuditEndpoints,
    FarmersEndpoints,
    TicketsEndpoints,
    FeedbackEndpoints,
    AdminEndpoints,
    FBOEndpoints,
    TrackerEndpoints,
    TractorsEndpoints,
    TractorRequestEndpoints,
    TransactionsEndpoints,
    UsersEndpoints,
    TractorOwnerEndpoints,
    MiscEndpoints,
    PermissionsEndpoint,
    TractorOperatorEndpoint,
    MediaEndpoints,
    AnalyticsEndpoints,
    AuthEndpoints,
    NotificationEndpoints,
    USSDEndpoints,
    PaymentsEndpoints,
    WalletEndpoints,
    VirtualCredit
}



// WEBPACK FOOTER //
// ./src/common/ProxyEndpoints.js